var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 897.6 692.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a6d6b637-71a5-4b76-813f-fd5bbc1cb5f2, .aebd25ba-a2e4-4467-902a-c4b040110a94 {\n        fill: #ee6e51;\n      }\n\n      .b90d2f8c-45a6-45bf-8900-08c70e71f1bd {\n        fill: #231f20;\n      }\n\n      .a5c16bf6-0a38-46c7-aa4f-1a26eaed4423, .a9c8e464-83ce-4824-8ec4-527c15ef0320, .b3a5285a-e4b6-489f-9999-32c415652e27, .b9060d28-f6f5-46d2-a2d6-06a16e1ccbba, .f302f32f-2dbb-4d7e-847e-74eb9fea103c {\n        fill: none;\n      }\n\n      .a5c16bf6-0a38-46c7-aa4f-1a26eaed4423, .a6d6b637-71a5-4b76-813f-fd5bbc1cb5f2, .a9c8e464-83ce-4824-8ec4-527c15ef0320, .b3a5285a-e4b6-489f-9999-32c415652e27, .f302f32f-2dbb-4d7e-847e-74eb9fea103c {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .b3a5285a-e4b6-489f-9999-32c415652e27, .b4c951eb-776d-422c-9913-4b5d0296096a, .f94112a7-4c57-415d-924c-38bf359fee17 {\n        stroke-width: 6px;\n      }\n\n      .b311b206-ac30-4c20-adcf-5a3baead80ba, .b4c951eb-776d-422c-9913-4b5d0296096a {\n        fill: #f4beb2;\n      }\n\n      .b4c951eb-776d-422c-9913-4b5d0296096a, .f94112a7-4c57-415d-924c-38bf359fee17 {\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .a6d6b637-71a5-4b76-813f-fd5bbc1cb5f2, .a9c8e464-83ce-4824-8ec4-527c15ef0320 {\n        stroke-width: 7.5px;\n      }\n\n      .f94112a7-4c57-415d-924c-38bf359fee17 {\n        fill: #92d4cd;\n      }\n\n      .a5c16bf6-0a38-46c7-aa4f-1a26eaed4423 {\n        stroke-width: 6.24px;\n      }\n\n      .f302f32f-2dbb-4d7e-847e-74eb9fea103c {\n        stroke-width: 6.21px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "technology") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac8df8c0-441a-4c10-8e7b-4028fa8ea9a6",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b289b9fe-bbd3-4c05-91cb-e6931e51684c",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aebd25ba-a2e4-4467-902a-c4b040110a94",
    cx: 722.58,
    cy: 10.31,
    r: 10.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 565.52,
    cy: 255.17,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 353.59,
    cy: 243.16,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 232.79,
    cy: 240.96,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 722.58,
    cy: 278.95,
    r: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 118.58,
    cy: 450.83,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-339.08 362.17) rotate(-64.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M119.8,449.31s27.06-88.08,98.65-70.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 433.58,
    cy: 392.54,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-132.04 243.7) rotate(-27.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M431.69,393s-74.52,54.21-121.4-2.59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 446.26,
    cy: 401.26,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-136.23 545.7) rotate(-55.89)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 772.57,
    cy: 512.04,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-84.64 864.52) rotate(-55.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M448.08,402s74.38,50.93,127.57,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b4c951eb-776d-422c-9913-4b5d0296096a",
    d: "M514.75,355.48l4.14-15.05-25.06-5a27.23,27.23,0,0,1-21.32-32.07l8.28-41.13L413.2,277.65a16.29,16.29,0,0,1-10.48-1.29,140,140,0,0,1-84.83,85.53h0c-13.95,6.34-13.92,14.8-12.35,19.74a105.87,105.87,0,0,1,4.16,17.55c4.47,32.27,1.44,54.6-2.65,68.8l25.21,5.38c7.34,1.57,13.77,7.92,16,15.86l24.75,86.55c4.41,15.42,22.4,21.71,30.6,10.69L460.16,483A13.52,13.52,0,0,1,469,477.7l77.61-1.7,21.57-54.89L521.45,377C515.45,371.34,512.76,362.71,514.75,355.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b9060d28-f6f5-46d2-a2d6-06a16e1ccbba",
    x: 570.24,
    y: 101.42,
    width: 180.5,
    height: 310.09,
    rx: 7.23,
    transform: "translate(1042.24 -340.44) rotate(101.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6d6b637-71a5-4b76-813f-fd5bbc1cb5f2",
    d: "M827.16,177.55,537.33,119.22a27.22,27.22,0,0,0-32.06,21.32L472.51,303.32a27.23,27.23,0,0,0,21.32,32.07l289.82,58.33a27.24,27.24,0,0,0,32.07-21.32l32.76-162.78A27.23,27.23,0,0,0,827.16,177.55Zm1.71,28.12L796.11,368.45a7.23,7.23,0,0,1-8.51,5.66L497.77,315.78a7.24,7.24,0,0,1-5.66-8.51l32.77-162.78a7.21,7.21,0,0,1,8.51-5.66l289.82,58.33A7.22,7.22,0,0,1,828.87,205.67Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    points: "677.26 146.22 702.99 133.39 660.49 119.67 713.66 114.39 670.4 90.69 706.51 90.69 722.58 10.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M686.09,412.78s63.14,51.7,86.48,99.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    x1: 660.49,
    y1: 689.4,
    x2: 639.8,
    y2: 580.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    x1: 610.78,
    y1: 689.4,
    x2: 590.08,
    y2: 580.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M258.88,521.23S275.39,572.48,232.79,629"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M218.45,514.15s-9.7,59.32-81.9,80.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b311b206-ac30-4c20-adcf-5a3baead80ba",
    d: "M100.89,148.36l21-4.45c4-.85,6.19-6.23,3.71-9.16L107.23,113a4.91,4.91,0,0,1-1-4l4.35-27.4c.7-4.38-3.41-6.89-7-4.26l-21.81,16a4.9,4.9,0,0,1-4,1l-29.8-6.87c-3.74-.86-7.53,3.55-6.45,7.5L47.92,118A6.33,6.33,0,0,1,46,124L27.6,141.38c-3.28,3.09-2.53,8.4,1.28,9l33.11.78a3.79,3.79,0,0,1,2.47,1.5l15.84,29.1c2.3,3.1,7.36,1.34,8.6-3l7.48-26A6.29,6.29,0,0,1,100.89,148.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f94112a7-4c57-415d-924c-38bf359fee17",
    d: "M472.75,385.64,482.88,360c1.93-4.89-2.29-11-7.17-10.47l-36.37,4.29a6.32,6.32,0,0,1-4.92-1.77L408.17,328c-4.2-3.85-9.79-1.22-9.51,4.46l1.67,34.67a6.28,6.28,0,0,1-1.78,4.92l-28.47,27c-3.56,3.39-1.53,10.57,3.47,12.21l29.17,9.59a8.13,8.13,0,0,1,5.14,6.31l5.52,32c1,5.7,7.19,8.65,10.56,5l24.28-34.9a4.9,4.9,0,0,1,3.36-1.58l42.36,3.65c4.95-.27,6.65-6.93,2.89-11.33l-22.51-26.4A8.06,8.06,0,0,1,472.75,385.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b311b206-ac30-4c20-adcf-5a3baead80ba",
    d: "M884.12,85.87l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.26a2.65,2.65,0,0,1-1.39-1.7l-4.28-14.29a2.29,2.29,0,0,0-4.38-.44l-6.84,12.84A2.6,2.6,0,0,1,860.36,65l-16.05,3.62c-2,.46-2.81,3.48-1.37,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37L847,99.58c-.87,2.26.73,4.66,2.72,4.07l16.22-7.34a2.08,2.08,0,0,1,1.55.15l14.46,10.4c1.83,1,3.87-1.06,3.47-3.45L883,89.08A3.39,3.39,0,0,1,884.12,85.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b311b206-ac30-4c20-adcf-5a3baead80ba",
    d: "M806.78,636.46l-2.85,11.2c-.54,2.13,1.54,4.47,3.54,4l14.88-3.71a2.63,2.63,0,0,1,2.14.48L836.67,657a2.29,2.29,0,0,0,3.72-2.36l-2.53-14.32a2.61,2.61,0,0,1,.48-2.14l10.39-12.74c1.3-1.6.08-4.48-2.09-4.89L834,618.12a3.42,3.42,0,0,1-2.47-2.35l-4-13c-.71-2.32-3.44-3.21-4.65-1.53L814.66,617a2.06,2.06,0,0,1-1.31.84l-17.8.73c-2,.37-2.39,3.23-.6,4.86l10.76,9.77A3.41,3.41,0,0,1,806.78,636.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b311b206-ac30-4c20-adcf-5a3baead80ba",
    d: "M39,504.45l3.48-8.81c.66-1.67-.79-3.78-2.46-3.59l-12.48,1.47a2.14,2.14,0,0,1-1.69-.61l-9-8.26a1.87,1.87,0,0,0-3.26,1.53l.57,11.9a2.18,2.18,0,0,1-.61,1.69l-9.77,9.28c-1.22,1.16-.53,3.62,1.19,4.19l10,3.29a2.78,2.78,0,0,1,1.76,2.17l1.89,11c.34,2,2.47,3,3.63,1.72l8.33-12a1.65,1.65,0,0,1,1.15-.54l14.54,1.25c1.7-.09,2.28-2.38,1-3.89l-7.72-9.06A2.76,2.76,0,0,1,39,504.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b3515d14-ad35-4aa2-b806-e57b27ee0e74",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 722.58,
    cy: 10.31,
    r: 10.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 565.52,
    cy: 255.17,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 353.59,
    cy: 243.16,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 232.79,
    cy: 240.96,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 722.58,
    cy: 278.95,
    r: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 118.58,
    cy: 450.83,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-339.08 362.17) rotate(-64.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M119.8,449.31s27.06-88.08,98.65-70.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 433.58,
    cy: 392.54,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-132.04 243.7) rotate(-27.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M431.69,393s-74.52,54.21-121.4-2.59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 446.26,
    cy: 401.26,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-136.23 545.7) rotate(-55.89)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b90d2f8c-45a6-45bf-8900-08c70e71f1bd",
    cx: 772.57,
    cy: 512.04,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-84.64 864.52) rotate(-55.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M448.08,402s74.38,50.93,127.57,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a9c8e464-83ce-4824-8ec4-527c15ef0320",
    d: "M220.08,390.22A39,39,0,0,0,203.72,353c-.44-.31-.9-.61-1.36-.9h0a139.65,139.65,0,0,1-71.15-124.3c1.37-76.54,65-138.13,141.57-137.09a139.69,139.69,0,0,1,45.11,271.19h0c-13.95,6.34-13.92,14.8-12.35,19.74a105.87,105.87,0,0,1,4.16,17.55c8.85,64-11.73,88.89-11.73,88.89s-24.44,34.14-45.54,34.14c-21.82,0-42.58-6.44-50.68-29.4a60.64,60.64,0,0,1,.95-42.08C208.58,435.52,217.5,410.17,220.08,390.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a9c8e464-83ce-4824-8ec4-527c15ef0320",
    x: 485.45,
    y: 146.22,
    width: 350.09,
    height: 220.5,
    rx: 27.23,
    transform: "translate(1257.4 638.22) rotate(-168.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a9c8e464-83ce-4824-8ec4-527c15ef0320",
    x: 570.24,
    y: 101.42,
    width: 180.5,
    height: 310.09,
    rx: 7.23,
    transform: "translate(1042.24 -340.44) rotate(101.38)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    points: "677.26 146.22 702.99 133.39 660.49 119.67 713.66 114.39 670.4 90.69 706.51 90.69 722.58 10.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    points: "669.58 370.76 754.97 588.04 508.52 572.81 593.9 355.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M686.09,412.78s63.14,51.7,86.48,99.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    x1: 660.49,
    y1: 689.4,
    x2: 639.8,
    y2: 580.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    x1: 610.78,
    y1: 689.4,
    x2: 590.08,
    y2: 580.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M258.88,521.23S275.39,572.48,232.79,629"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3a5285a-e4b6-489f-9999-32c415652e27",
    d: "M218.45,514.15s-9.7,59.32-81.9,80.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5c16bf6-0a38-46c7-aa4f-1a26eaed4423",
    d: "M884.12,85.87l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.26a2.65,2.65,0,0,1-1.39-1.7l-4.28-14.29a2.29,2.29,0,0,0-4.38-.44l-6.84,12.84A2.6,2.6,0,0,1,860.36,65l-16.05,3.62c-2,.46-2.81,3.48-1.37,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37L847,99.58c-.87,2.26.73,4.66,2.72,4.07l16.22-7.34a2.08,2.08,0,0,1,1.55.15l14.46,10.4c1.83,1,3.87-1.06,3.47-3.45L883,89.08A3.39,3.39,0,0,1,884.12,85.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5c16bf6-0a38-46c7-aa4f-1a26eaed4423",
    d: "M806.78,636.46l-2.85,11.2c-.54,2.13,1.54,4.47,3.54,4l14.88-3.71a2.63,2.63,0,0,1,2.14.48L836.67,657a2.29,2.29,0,0,0,3.72-2.36l-2.53-14.32a2.61,2.61,0,0,1,.48-2.14l10.39-12.74c1.3-1.6.08-4.48-2.09-4.89L834,618.12a3.42,3.42,0,0,1-2.47-2.35l-4-13c-.71-2.32-3.44-3.21-4.65-1.53L814.66,617a2.06,2.06,0,0,1-1.31.84l-17.8.73c-2,.37-2.39,3.23-.6,4.86l10.76,9.77A3.41,3.41,0,0,1,806.78,636.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5c16bf6-0a38-46c7-aa4f-1a26eaed4423",
    d: "M39,504.45l3.48-8.81c.66-1.67-.79-3.78-2.46-3.59l-12.48,1.47a2.14,2.14,0,0,1-1.69-.61l-9-8.26a1.87,1.87,0,0,0-3.26,1.53l.57,11.9a2.18,2.18,0,0,1-.61,1.69l-9.77,9.28c-1.22,1.16-.53,3.62,1.19,4.19l10,3.29a2.78,2.78,0,0,1,1.76,2.17l1.89,11c.34,2,2.47,3,3.63,1.72l8.33-12a1.65,1.65,0,0,1,1.15-.54l14.54,1.25c1.7-.09,2.28-2.38,1-3.89l-7.72-9.06A2.76,2.76,0,0,1,39,504.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f302f32f-2dbb-4d7e-847e-74eb9fea103c",
    d: "M100.89,148.36l21-4.45c4-.85,6.19-6.23,3.71-9.16L107.23,113a4.91,4.91,0,0,1-1-4l4.35-27.4c.7-4.38-3.41-6.89-7-4.26l-21.81,16a4.9,4.9,0,0,1-4,1l-29.8-6.87c-3.74-.86-7.53,3.55-6.45,7.5L47.92,118A6.33,6.33,0,0,1,46,124L27.6,141.38c-3.28,3.09-2.53,8.4,1.28,9l33.11.78a3.79,3.79,0,0,1,2.47,1.5l15.84,29.1c2.3,3.1,7.36,1.34,8.6-3l7.48-26A6.29,6.29,0,0,1,100.89,148.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.192379f6d6589f7d11e8111f817d3918.svg";
export { ForwardRef as ReactComponent };